var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#457A14",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.5 26C32.57 26 29.375 29.195 29.375 33.125C29.375 36.98 32.39 40.1 36.32 40.235C36.44 40.22 36.56 40.22 36.65 40.235C36.68 40.235 36.695 40.235 36.725 40.235C36.74 40.235 36.74 40.235 36.755 40.235C40.595 40.1 43.61 36.98 43.625 33.125C43.625 29.195 40.43 26 36.5 26Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.12 44.2249C39.935 41.4349 33.11 41.4349 28.895 44.2249C26.99 45.4999 25.94 47.2249 25.94 49.0699C25.94 50.9149 26.99 52.6249 28.88 53.8849C30.98 55.2949 33.74 55.9999 36.5 55.9999C39.26 55.9999 42.02 55.2949 44.12 53.8849C46.01 52.6099 47.06 50.8999 47.06 49.0399C47.045 47.1949 46.01 45.4849 44.12 44.2249Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.985 34.01C53.225 36.92 51.155 39.47 48.29 39.815C48.275 39.815 48.275 39.815 48.26 39.815H48.215C48.125 39.815 48.035 39.815 47.96 39.845C46.505 39.92 45.17 39.455 44.165 38.6C45.71 37.22 46.595 35.15 46.415 32.9C46.31 31.685 45.89 30.575 45.26 29.63C45.83 29.345 46.49 29.165 47.165 29.105C50.105 28.85 52.73 31.04 52.985 34.01Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.985 47.885C55.865 49.34 54.935 50.6 53.375 51.455C51.875 52.28 49.985 52.67 48.11 52.625C49.19 51.65 49.82 50.435 49.94 49.145C50.09 47.285 49.205 45.5 47.435 44.075C46.43 43.28 45.26 42.65 43.985 42.185C47.3 41.225 51.47 41.87 54.035 43.94C55.415 45.05 56.12 46.445 55.985 47.885Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse4);
export default __webpack_public_path__ + "static/media/Ellipse4.7be0e6e764aedb6386d2a708a6a901f1.svg";
export { ForwardRef as ReactComponent };